<template>
    <div>
        <HeaderComponent :title="affiliate.name + ': Affiliate Submissions'" :actions="[
            {label: 'Download as CSV', click: downloadCSV, class: 'bg-blue-500 text-white'}, 
        ]"/>
        <DataTable :value="affiliateSubmissions" v-if="affiliateSubmissions.length >= 1">
            <Column
                v-for="field in fields"
                :key="field"
                :field="field"
                :header="humanize(field)"
            >
                <template #body="{ data }">
                    {{ data[field] ?? '-' }}
                </template>
            </Column>
            <Column field="actions" header="" v-if="authUser.is_admin">
                <template #body="{ data }">
                    <button @click="deleteSubmission(data)" class="bg-red-500 text-white px-4 py-2 rounded">
                        Delete
                    </button>
                </template>
            </Column>
        </DataTable>
        <p class="text-2xl font-bold text-center" v-else>No Responses</p>
    </div>
</template>
<script setup>
import { computed } from "vue";
import { usePage, router } from "@inertiajs/vue3";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import HeaderComponent from "@/Components/HeaderComponent.vue";
import humanize from "@/Utilities/Humainze";

const page = usePage();
const affiliateSubmissions = computed(() =>
    page.props.affiliate.affiliate_submissions.map((x) => ({
        id: x.id,
        ...x.values,
        created: new Date(x.created).toLocaleString(),
        status: x.affiliate_submission_status?.status,
    })),
);
const affiliateSubmissionStatuses = computed(() => page.props.affiliateSubmissionStatuses);
const authUser = computed(() => page.props.authUser);

const affiliate = computed(() => page.props.affiliate);
const fields = computed(() => {
    const allKeys = new Set();
    affiliateSubmissions.value.forEach((submission) => {
        Object.keys(submission).forEach((key) => allKeys.add(key));
    });
    return Array.from(allKeys);
});

const downloadCSV = () => {
    const csvContent = [
        fields.value.join(","),
        ...affiliateSubmissions.value.map((submission) =>
            fields.value.map((field) => submission[field] || "").join(","),
        ),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "affiliate_submissions.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const deleteSubmission = (submission) => {
    if (confirm("Are you sure you want to delete this submission?")) {
        router.post(
            `/delete-submissions/${submission.id}`,
            {
                _csrfToken: usePage().props._csrfToken,
            },
            {
                onSuccess: () => {
                    affiliateSubmissions.value =
                        affiliateSubmissions.value.filter(
                            (x) => x.id !== submission.id,
                        );
                },
            },
        );
    }
};
</script>
